import { FC } from 'react';

import { RelativeTime } from '@bonusly/common-relative-time';
import { Flex } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { BizyAttribution } from './bizy-attribution';

/**
 * Bizy attribution (when present) and timestamp for bonus card headers.
 * Stacks vertically on mobile so the header fits; inline on sm+.
 */
export const BonusHeaderMeta: FC<{ bonus: Bonus }> = ({ bonus }) => (
	<Flex align={{ base: 'flex-end', sm: 'center' }} direction={{ base: 'column', sm: 'row' }} flexShrink={0}>
		<BizyAttribution bonus={bonus} />
		<RelativeTime color="text.softest" fontSize={{ base: 'sm', sm: 'md' }} date={new Date(bonus.created_at)} />
	</Flex>
);
